// extracted by mini-css-extract-plugin
export default {"contactContainer":"Contact_contactContainer__EZpLs","content":"Contact_content__Dta7P","eachContent":"Contact_eachContent__-esw1","form":"Contact_form__pahXH"};